import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "edit" }
const _hoisted_2 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_tree = _resolveComponent("el-tree")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.show,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.show) = $event)),
      onClose: _ctx.close,
      title: _ctx.isEdit ? '编辑角色' : '新增角色',
      center: "",
      width: "50%",
      "before-close": _ctx.handleClose
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_2, [
          _createVNode(_component_el_button, { onClick: _ctx.close }, {
            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
              _createTextVNode("取消", -1)
            ]))]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _ctx.submitForm
          }, {
            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
              _createTextVNode("提交", -1)
            ]))]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("span", null, [
          _createElementVNode("div", null, [
            _createVNode(_component_el_form, {
              ref: "ruleFormRef",
              model: _ctx.ruleForm,
              rules: _ctx.rules,
              "label-width": "120px",
              class: "demo-ruleForm"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "角色名称",
                  prop: "roleName"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.ruleForm.roleName,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.ruleForm.roleName) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "角色编码",
                  prop: "roleCode"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.ruleForm.roleCode,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.ruleForm.roleCode) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "角色描述",
                  prop: "description"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.ruleForm.description,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.ruleForm.description) = $event)),
                      type: "textarea"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "菜单权限",
                  prop: "menuIds"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_tree, {
                      ref: "treeRef",
                      data: _ctx.data,
                      "node-key": "id",
                      "show-checkbox": "",
                      "check-on-click-node": "",
                      props: _ctx.defaultProps,
                      onCheckChange: _ctx.getNodes
                    }, null, 8, ["data", "props", "onCheckChange"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model", "rules"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "onClose", "title", "before-close"])
  ]))
}